"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = require("./error");
class TwingCallableWrapper {
    constructor(name, callable) {
        this.name = name;
        this.callable = callable;
    }
    getName() {
        return this.name;
    }
    /**
     * @returns {Function}
     */
    getCallable() {
        return this.callable;
    }
    /**
     * Returns the traceable callable.
     *
     * @param {number} lineno
     * @param {TwingSource} source
     * @return {Function}
     */
    traceableCallable(lineno, source) {
        let callable = this.callable;
        return function () {
            try {
                return callable.apply(null, arguments);
            }
            catch (e) {
                if (e instanceof error_1.TwingError) {
                    if (e.getTemplateLine() === -1) {
                        e.setTemplateLine(lineno);
                        e.setSourceContext(source);
                    }
                }
                throw e;
            }
        };
    }
}
exports.TwingCallableWrapper = TwingCallableWrapper;
